import { render } from "./CdaStagedItemNotes.vue?vue&type=template&id=43763ad8&scoped=true"
import script from "./CdaStagedItemNotes.vue?vue&type=script&lang=js"
export * from "./CdaStagedItemNotes.vue?vue&type=script&lang=js"

import "./CdaStagedItemNotes.vue?vue&type=style&index=0&id=43763ad8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43763ad8"]])

export default __exports__